export default {"src":"/_next/static/image/public/images/flags/flag_1246.c55cec81a6346aa927cbefcd86f62ba5.svg","height":16,"width":25};